module.exports = __webpack_public_path__ + "static/media/ru-ru.0e471841.png";